import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex xs2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Frequency:")
], -1)
const _hoisted_2 = { class: "flex xs8" }

import { UserFrequency } from "../notifi_types";
import { computed, ref } from "vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: ["modelValue", "subscription"],
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props



// eslint-disable-next-line no-undef


const selectedOption = computed({
  get() {
    return props.modelValue;
  },
  set(value: typeof UserFrequency) {
    emit("update:modelValue", value);
  },
});
const options = ref(Object.entries(UserFrequency));

return (_ctx: any,_cache: any) => {
  const _component_va_radio = _resolveComponent("va-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
        return (_openBlock(), _createBlock(_component_va_radio, {
          key: index,
          modelValue: _unref(selectedOption),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedOption) ? (selectedOption).value = $event : null)),
          option: option[0]
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option[1]), 1)
          ]),
          _: 2
        }, 1032, ["modelValue", "option"]))
      }), 128))
    ])
  ], 64))
}
}

})